import { BaseModel } from './base.model';

export class SignUpSecurityModel extends BaseModel {
  password: string | number;
}
